import { configureStore} from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
//网站
import { loginReducer } from './loginSlice'
import { firmLoginReducer } from './firmLoginSlice'
import { deptReducer } from './deptSlice';
import zd_enterprise_userApi from './zd_enterprise_userApi'
//业务管理
import ReactWebSiteApi from './ReactWebSiteApi'
import BnsKeJiApi from './BnsKeJiApi'
import dianshangtaizhangApi from './dianshangtaizhangApi'
import feiyongbaoxiaoApi from './feiyongbaoxiaoApi'
import NeiZhangFeiYongApi from './NeiZhangFeiYongApi'
//人事管理
import zd_enterprise_deptApi from './zd_enterprise_deptApi'
import React_enterpriseApi from './React_enterpriseApi'
//财务管理
import ReactWebSiteFinanceApi from './ReactWebSiteFinanceApi'
import reactapiApi from './reactapiApi'
import { tagReducer } from './tagSlice'; // 加上这一行
//意见反馈单
import YijiandanApi from './YijiandanapiApi'
//船票结算价
import ChuanPiaoApi from './ChuanPiaoApi'
const store = configureStore({
    reducer: {
        //网站       
        login: loginReducer,    
        firmLogin: firmLoginReducer,
        dept: deptReducer,     
        [zd_enterprise_userApi.reducerPath]: zd_enterprise_userApi.reducer,
        [BnsKeJiApi.reducerPath]: BnsKeJiApi.reducer,
        [dianshangtaizhangApi.reducerPath]: dianshangtaizhangApi.reducer,
        [feiyongbaoxiaoApi.reducerPath]: feiyongbaoxiaoApi.reducer,
        [NeiZhangFeiYongApi.reducerPath]: NeiZhangFeiYongApi.reducer,
        [ChuanPiaoApi.reducerPath]: ChuanPiaoApi.reducer,
        //我的
        [zd_enterprise_deptApi.reducerPath]: zd_enterprise_deptApi.reducer,
        
        //业务管理
        [ReactWebSiteApi.reducerPath]: ReactWebSiteApi.reducer,   
        //人事管理
        [React_enterpriseApi.reducerPath]: React_enterpriseApi.reducer,   
        //财务管理
        [ReactWebSiteFinanceApi.reducerPath]: ReactWebSiteFinanceApi.reducer,   
        [reactapiApi.reducerPath]: reactapiApi.reducer,   
        [YijiandanApi.reducerPath]: YijiandanApi.reducer,   
        tag: tagReducer, // ★★★ 必须加上这一行 ★★★
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(
            //网站
            zd_enterprise_deptApi.middleware,
            zd_enterprise_userApi.middleware,
            BnsKeJiApi.middleware,
            dianshangtaizhangApi.middleware,
            feiyongbaoxiaoApi.middleware,
            NeiZhangFeiYongApi.middleware,
            //业务管理
            ReactWebSiteApi.middleware,
            //人事管理
            React_enterpriseApi.middleware,
            //财务管理
            ReactWebSiteFinanceApi.middleware,
            reactapiApi.middleware,
            YijiandanApi.middleware,
            ChuanPiaoApi.middleware,
        ),
    
    }
);

setupListeners(store.dispatch)

export default store;